import Contact from './footer/contact.component'
import Magazine from './footer/magazine.component'
import Info from './footer/info.component'
import WaterMark from './waterMark.component'
import { version } from '../config/index'
import Image from 'next/image'
import { imageLoaderForStaticImages } from '../context/utils'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useAppContext } from '../context/siteMapContext'

const ActionButton: React.FC = () => {
  const { highContrastOn } = useAppContext();
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }
  return (
    <div
      className='absolute z-1 -top-12 right-desktop h-20 w-20 lg:h-24 lg:w-24'
      onClick={handleClick}
    >
      <Image
        loader={imageLoaderForStaticImages}
        alt='Ugrás az oldal tetejére'
        title='Ugrás az oldal tetejére'
        src={highContrastOn ? '/footer/Icon_hc_navigation_up.svg' : '/footer/Icon_navigation_up.svg'}
        layout='fill'
        objectFit='cover'
        width={60}
        height={60}
        className='cursor-pointer'
      />
    </div>
  )
}

const Footer: React.FC<any> = (props) => {
  const {
    issueLink,
    issueCover,
    sloganBottom_HU,
    address,
    addressTitle,
    phone,
    mailTo,
  } = props

  const { highContrastOn } = useAppContext();
  const router = useRouter();

  return (
    <footer className={`relative text-white mt-20 ${highContrastOn ? 'border-t-[6px]' : ''}`}>
      <div className={`h-auto bg-footer-background px-page-side-padding grid pt-10 pb-32 grid-cols-4 grid-rows-3 2xl:grid-cols-12 2xl:grid-rows-1 2xl:h-footer-2xl 2xl:py-14 ${highContrastOn ? 'bg-[#333]' : ''}`}>
        <div className='z-1 col-span-4 row-span-1 col-start-1 flex flex-col justify-center h-full'>
          <Contact
            slogan={sloganBottom_HU}
            phone={phone}
            mailTo={mailTo}
            addressTitle={addressTitle}
            address={address}
          />
        </div>
        <div className='z-1 col-span-4 row-span-1 col-start-1 2xl:col-span-2 2xl:col-start-6 text-center h-full'>
          <Magazine issueLink={issueLink} issueCover={issueCover} />
        </div>
        <div className='z-1 col-span-4 row-span-1 col-start-1 2xl:col-span-3 2xl:col-start-10 text-right h-60'>
          <Info {...props} />
        </div>
        <div className='row-span-1 col-start-1 col-span-4 2xl:col-start-8 2xl:col-span-5 place-self-end h-0 2xl:h-auto'>
          <WaterMark transparent={true} isLarge={true} />
        </div>
      </div>
      <div className='absolute right-2 bottom-2 text-lg'>{version}</div>
    </footer>
  )
}

export default Footer
